/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { LocoIncident } from '../../../loco/shared/model/loco-incident.model';

/**
 * @export
 * @class LmsLocoProblemsComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-problems',
  templateUrl: './lms-loco-problems.component.html',
  styleUrls: ['./lms-loco-problems.component.scss']
})
export class LmsLocoProblemsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() listOfIncident: Array<LocoIncident>;
  shownList: number;
  @Input() locoLabel: any;

  /**
   * Creates an instance of LmsLocoProblemsComponent.
   *
   * @memberOf LmsLocoProblemsComponent
   */
  constructor() {
  }

  /**
   * @memberOf LmsLocoProblemsComponent
   */
  ngOnInit() {
  }

  /**
   * Modify list of incidents when component changes
   * @memberOf LmsLocoProblemsComponent
   */
  ngOnChanges() {
    if (this.listOfIncident.length > 3) {
      this.shownList = 3;
    } else {
      this.shownList = this.listOfIncident.length;
    }
  }

  /**
    * Show more list when show more is clicked
    * @memberOf LmsLocoProblemsComponent
    */
  showMoreList() {
    this.shownList = this.listOfIncident.length;
  }

  /**
    * Show less list when show less is clicked
    * @memberOf LmsLocoProblemsComponent
    */
  showLessList() {
    this.shownList = 3;
  }

  /**
   * This Method is used to apply class to particular Error Band
   * @param {string} incidentType
   * @param {string} incidentCode
   * @returns {string}
   * @memberOf LmsLocoProblemsComponent
   */
  getIncidentClass(incidentType: string, incidentCode: string): string {
    if (incidentType.toUpperCase() === 'D' || incidentCode.toUpperCase() === 'DAD') {
      return 'red-problem';
    } else {
      return 'yellow-problem';
    }
  }

  /**
   * @memberOf LmsLocoProblemsComponent
   */
  ngOnDestroy() {
  }
}
